import { History } from "lucide-react";

/**
 * Extracted history sub-component — keeps ReplyDialog small and focused
 * on the editor while this component owns the collapsible reply log.
 */
export default function ReplyHistoryList({ history, showHistory, onToggle }) {
  if (!history?.length) return null;
  return (
    <div className="border border-gray-200">
      <button
        type="button"
        onClick={onToggle}
        className="w-full flex items-center justify-between px-4 py-2 bg-[var(--trj-light)] text-[12px] text-[var(--trj-navy)] font-semibold"
        data-testid="reply-history-toggle"
      >
        <span className="flex items-center gap-2">
          <History className="w-3.5 h-3.5 text-[var(--trj-green)]" /> Previous replies ({history.length})
        </span>
        <span className="text-[var(--trj-muted)]">{showHistory ? "Hide" : "Show"}</span>
      </button>
      {showHistory && (
        <ul className="divide-y divide-gray-100" data-testid="reply-history-list">
          {history.map((h) => (
            <li key={h.id} className="px-4 py-3 text-[12px]">
              <div className="flex items-center justify-between">
                <div className="font-medium text-[var(--trj-navy)] truncate">{h.subject}</div>
                <div className="text-[var(--trj-muted)] shrink-0 ml-3">
                  {new Date(h.created_at).toLocaleString()}
                </div>
              </div>
              <div className="text-[var(--trj-muted)] text-[11px] mt-0.5">
                Sent by {h.sent_by} via template <code>{h.template_id || "—"}</code>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
